/**
 * Кнопка отправки формы входа: дверь улей + успех/ошибка по state machine (otp-verification-v3).
 */

import { useTranslation } from "react-i18next";

export type AuthSubmitPhase = "idle" | "checking" | "walking" | "ok" | "error";

export interface AuthSubmitButtonProps {
  readonly label: string;
  readonly phase: AuthSubmitPhase;
  readonly disabled: boolean;
  readonly onClick: () => void;
}

export function AuthSubmitButton({
  label,
  phase,
  disabled,
  onClick,
}: AuthSubmitButtonProps): React.JSX.Element {
  const { t } = useTranslation("common");

  const busy = phase === "checking" || phase === "walking" || phase === "ok";
  const className = [
    "auth-submit",
    phase === "checking" ? "auth-submit--checking" : "",
    phase === "walking" ? "auth-submit--walking auth-submit--dooropen" : "",
    phase === "ok" ? "auth-submit--success" : "",
    phase === "error" ? "auth-submit--error" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const live =
    phase === "checking"
      ? t("auth.checking")
      : phase === "ok"
        ? t("auth.success")
        : phase === "error"
          ? t("auth.failed")
          : "";

  return (
    <>
      <button
        type="button"
        className={className}
        disabled={disabled || busy}
        onClick={onClick}
        aria-busy={busy}
      >
        <span className="auth-submit__label">{label}</span>
        <span className="auth-submit__door" aria-hidden="true">
          <span className="auth-submit__door-frame">
            <span className="auth-submit__door-glow" />
            <span className="auth-submit__door-panel">
              <span className="auth-submit__door-handle" />
            </span>
          </span>
          <span className="auth-submit__walker">
            <svg viewBox="0 0 24 28" width="22" height="26" aria-hidden="true">
              <circle cx="12" cy="4.5" r="3.2" fill="currentColor" />
              <rect x="10.5" y="7.5" width="3" height="8" rx="1.2" fill="currentColor" />
              <rect x="6" y="8" width="3" height="9" rx="1.2" fill="currentColor" className="auth-submit__arm auth-submit__arm--back" />
              <rect x="15" y="8" width="3" height="9" rx="1.2" fill="currentColor" className="auth-submit__arm auth-submit__arm--front" />
              <rect x="8.5" y="15" width="3" height="10" rx="1.2" fill="currentColor" className="auth-submit__leg auth-submit__leg--back" />
              <rect x="12.5" y="15" width="3" height="10" rx="1.2" fill="currentColor" className="auth-submit__leg auth-submit__leg--front" />
            </svg>
          </span>
        </span>
        <svg className="auth-submit__check" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 12.5 10 17.5 19 7.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <p className="auth-submit__live" aria-live="polite">
        {live}
      </p>
    </>
  );
}
